import { createContext, useContext } from 'react'
import { FormsViewData } from '../../types/views'
import { emptyPopulatedAssessmentInterface } from './AssessmentContext'

export const FormsViewContext = createContext<FormsViewData>({
  step: 'questions',
  selectStep: () => {},
  selected: null,
  open: () => {},
  close: () => {},
  assessmentIndex: null,
  assessmentsLoading: false,
  assessments: null,
  populatedUser: {
    adminPatientRef: null,
    isInvite: false,
    loading: false,
    practicePatientRef: null,
    patientRef: null,
    user: null,
    adminItem: null,
  },
  userId: '',
  form: null,
  progress: {
    questions: { name: 'Questions', progress: 0, active: false, visible: false },
    view: { name: 'View', progress: 0, active: false, visible: false },
    signOn: { name: 'Sign On', progress: 0, active: false, visible: false },
  },
  formData: {},
  formCorrections: null,
  assessment: emptyPopulatedAssessmentInterface,
  signOnData: {
    signOnStagesComplete: false,
    signOnFormComplete: false,
    insuranceCallInComplete: false,
    insuranceCallInForm: null,
    assessmentConsentFormsComplete: false,
    insuranceCallInSubmittedOn: null,
    consentFormsStatus: {
      missingConsentForms: [],
      hbConsentForms: [],
      practiceConsentForms: [],
      selectedConsentForm: null,
      handleViewConsentForm: () => {},
      handleCloseModal: () => {},
      onSignConsentForm: undefined,
      canDownload: false,
      complete: false,
      numConsentForms: 0,
      numSignedConsentForms: 0,
      consentForms: {},
      // patientConsentForms: emptyUseQuery,
    },
  },
  questionnaireSummaryComplete: false,
})

export const useFormsView = () => useContext(FormsViewContext)
